import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

import { PageLoadError } from '@app/components/error';
import { Hr } from '@app/components/hr';
import { Loader } from '@app/components/loader';
import { ProductCard } from '@app/components/product-card';
import { mapDispatchToProps } from '@app/store/map-dispatch-to-props';

const ICasContainerRaw = ({ app, content, actions }) => {
	const [isLoading, setIsLoading] = React.useState(true);

	const { apiError } = app;
	const { iCas } = content;

	React.useEffect(() => {
		const fx = async function getICas() {
			await actions.getICas();

			setIsLoading(false);
		};
		setTimeout(fx, 2000);
	}, [actions]);

	const iCasSections =
		iCas.sections &&
		iCas.sections.map((section) => (
			<section
				className="u-padding-top u-padding-bottom u-width-100"
				key={section.sectionHeader}
			>
				<h2 className="u-margin-hug">{section.sectionHeader}</h2>
				<Hr light md offset />

				{section.courses &&
					section.courses.map((item, courseIndex) => (
						<ProductCard
							key={item.id}
							index={courseIndex}
							item={item}
							courseDocuments={item.courseDocuments}
							hasExamWindows
						/>
					))}
			</section>
		));

	return (
		<div className="u-padding-md-top u-padding-bottom u-bg-light">
			<div className="container container--max-width">
				<div
					className={classNames('container__grid', {
						'has-error': apiError.errorType === 'page',
						'has-loader': isLoading,
						'loading-graphic__parent': isLoading,
					})}
				>
					{isLoading && <Loader />}

					{!isLoading &&
						apiError.api === 'icas' &&
						apiError.errorType === 'page' && <PageLoadError />}

					{!isLoading &&
						apiError.api !== 'icas' &&
						apiError.errorType !== 'page' &&
						iCasSections}
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = ({ app, cart, form, content }) => ({
	app,
	cart,
	content,
	form,
});

export const ICasContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
)(ICasContainerRaw);

export default ICasContainer;
